import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_TRANSPARENT } from "@/lib/i18n";

export default function Loader() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Wait for window load + small grace
    const onReady = () => {
      setTimeout(() => setVisible(false), 1100);
    };
    if (document.readyState === "complete") {
      onReady();
    } else {
      window.addEventListener("load", onReady);
      // safety timeout
      const safety = setTimeout(() => setVisible(false), 2500);
      return () => {
        window.removeEventListener("load", onReady);
        clearTimeout(safety);
      };
    }
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-ink-900"
          data-testid="site-loader"
        >
          <motion.img
            src={LOGO_TRANSPARENT}
            alt="Villa Reset Ibiza"
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
            className="w-56 md:w-72 select-none pointer-events-none"
            draggable={false}
          />
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
            className="absolute bottom-16 left-1/2 -translate-x-1/2 w-32 h-px bg-gold/40 origin-left"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
